<template>
  <div class="tw:p-4">
    <div class="tw:flex tw:items-center tw:justify-between">
      <div class="tw:mb-2 tw:font-bold">
        {{ getLocaleText("stream_filters_tags.tag") }}
      </div>
      <div>
        <a
          v-if="tags.length || excludedTags.length"
          class="tw:cursor-pointer tw:text-denim-400 tw:hover:text-denim-700"
          data-testid="clear-all"
          @click="clearAll"
        >
          {{ getLocaleText("stream_filters_content.clear_all") }}
        </a>
      </div>
    </div>
    <div class="tw:mb-2 tw:flex">
      <Tabs
        v-model="tagsTab"
        class="tw:font-bold"
        data-testid="tabs"
        type="toggles"
      >
        <Tab
          data-testid="include-tab"
          :label="getLocaleText('stream_filters_content.include')"
          name="include"
          new-design
          type="toggle"
        />
        <Tab
          data-testid="exclude-tab"
          :label="getLocaleText('stream_filters_content.exclude')"
          name="exclude"
          new-design
          type="toggle"
        />
      </Tabs>
    </div>
    <div class="tw:mb-1 tw:text-xs tw:text-denim-700">
      {{ notAvailable }}
    </div>
    <div class="tw:flex tw:flex-col tw:gap-2">
      <DropdownTags
        v-model:tags="localTags"
        :stream="stream"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";

import { getLocaleText } from "shared/boot/i18n";
import { Tab, Tabs } from "shared/components/base";
import DropdownTags from "shared/components/selectors/expandables/DropdownTags.vue";
import type { StreamFiltersTag } from "shared/helpers/StreamFilters";
import type { Stream } from "shared/types";

interface StreamFiltersTagsProps {
  stream: Stream;
}

defineProps<StreamFiltersTagsProps>();

const tags = defineModel<StreamFiltersTag[]>("tags", {
  default: () => [],
});

const excludedTags = defineModel<StreamFiltersTag[]>("excludedTags", {
  default: () => [],
});

const tagsTab = ref(excludedTags.value.length ? "exclude" : "include");

const notAvailable = computed(() => {
  if (tagsTab.value === "include") {
    return getLocaleText("stream_filters_content.excluded_not_available");
  }

  return getLocaleText("stream_filters_content.included_not_available");
});

const localTags = computed<StreamFiltersTag[]>({
  get() {
    return tagsTab.value === "exclude" ? excludedTags.value : tags.value;
  },
  set(value) {
    if (tagsTab.value === "exclude") {
      excludedTags.value = value;
    } else {
      tags.value = value;
    }
  },
});

function clearAll() {
  tags.value = [];
  excludedTags.value = [];
}

watch(tagsTab, () => {
  clearAll();
});
</script>
